// This file was automatically generated from appchart.dialog.ordermed.newMed.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.ordermed.newMed');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.ordermed.newMed.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form id="create-new-med-form" class="el8DialogContainer"><div class="el8FieldSection"><label class="el8label el8FieldMedium el8FieldRequired"><span class="el8FieldSection"><span class="el8RequiredStyle">*</span>Name:</span></label><div class="el8FieldMediumLabelPadding el8TextareaWrap"><input type="text" class="w100" name="brandName" /></div></div><div class="el8FieldSection"><label class="el8label el8FieldMedium el8FieldRequired">Strength:</label><div class="el8FieldMediumLabelPadding el8TextareaWrap"><input type="text" class="w100" name="strength" /></div></div><div class="el8FieldMediumLabelPadding el8StandardFontSize"><input name="medType" type="radio" class="options" value="prescription" />Rx<input name="medType" type="radio" class="options" value="otc" />OTC<input name="medType" type="radio" class="options" value="controlled" />Controlled</div></form>');
  if (!opt_sb) return output.toString();
};
